import React from "react";
import { motion } from "framer-motion";
import { IMAGES, STATS } from "@/lib/data";

export const Bio = () => {
  return (
    <section id="bio" data-testid="bio-section" className="relative py-28 md:py-40 overflow-hidden">
      <div
        className="absolute inset-0 opacity-30 pointer-events-none"
        style={{
          backgroundImage: `url(${IMAGES.tsunamiBg})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          maskImage: "radial-gradient(ellipse at center, black 30%, transparent 80%)",
          WebkitMaskImage: "radial-gradient(ellipse at center, black 30%, transparent 80%)",
        }}
      />
      <div className="absolute inset-0 bg-gradient-to-b from-ink-950 via-transparent to-ink-950 pointer-events-none" />

      <div className="relative max-w-[1400px] mx-auto px-6 md:px-10">
        <div className="grid grid-cols-12 gap-6 md:gap-10">
          <motion.div
            initial={{ opacity: 0, x: -30 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true, margin: "-100px" }}
            transition={{ duration: 0.8 }}
            className="col-span-12 md:col-span-3 md:pt-4"
          >
            <div className="text-xs tracking-[0.4em] uppercase text-cyan-glow mb-4">
              ◢ Origin of the Tsunami
            </div>
            <div className="font-serif italic text-slate-400 text-lg">
              Born on the <span className="text-gold">coast of New England</span>. Forged in <span className="text-gold">gold</span>.
            </div>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-100px" }}
            transition={{ duration: 0.9, delay: 0.1 }}
            className="col-span-12 md:col-span-9"
          >
            <h2 className="font-display font-black uppercase text-4xl md:text-6xl lg:text-7xl leading-[0.95] tracking-tighter">
              He didn't <span className="font-serif italic font-medium text-gold normal-case">arrive</span>.
              <br />
              He <span className="text-shimmer-gold">crashed</span> the coast.
            </h2>

            <div className="mt-10 grid grid-cols-1 md:grid-cols-2 gap-8 text-slate-300 font-light text-base md:text-lg leading-relaxed max-w-[1100px]">
              <p>
                Cassius Grate is an American artist whose sound moves like a <span className="text-gold">tsunami</span> —
                vast, immediate, impossible to contain. A platinum plaque on the wall,
                a voice that fuses East Coast hip-hop, Southern R&B lushness, and
                electronic euphoria into one rising tide.
              </p>
              <p>
                Every record is a coastline. Every show, a new <span className="text-gold font-serif italic">tsunami</span>. The
                Tsunami Era is not a project — it's a weather pattern. And he is the
                front of the storm.
              </p>
            </div>

            <div className="mt-14 grid grid-cols-2 md:grid-cols-4 gap-px bg-white/10 border border-white/10">
              {STATS.map((s, i) => (
                <div
                  key={i}
                  data-testid={`stat-${i}`}
                  className="bg-ink-950 px-6 py-8 md:px-8 md:py-10 hover:bg-ink-900 transition-colors"
                >
                  <div className="font-display font-black text-3xl md:text-5xl text-shimmer-gold tracking-tight">
                    {s.value}
                  </div>
                  <div className="mt-2 text-[10px] md:text-xs tracking-[0.3em] uppercase text-slate-400">
                    {s.label}
                  </div>
                </div>
              ))}
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
};
